export default "__VITE_ASSET__d18cd77b__"